import { Flex, Text, csx } from '@vtex/admin-ui'

import { FormattedDate, FormattedTime } from 'react-intl'

import type { ColumnParams, GenericPromotion } from 'typings'

const EMPTY_DATE = '-'

export function EndDate(props: ColumnParams<GenericPromotion>) {
  const {
    item: { endDate },
  } = props

  return endDate ? (
    <Flex
      direction="column"
      justify="center"
      className={csx({ height: 'full' })}
    >
      <Text>
        <FormattedDate
          value={endDate}
          month="short"
          day="2-digit"
          year="numeric"
        />
      </Text>
      <Text tone="secondary">
        <FormattedTime value={endDate} />
      </Text>
    </Flex>
  ) : (
    EMPTY_DATE
  )
}
